"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Warning = _ref => {
  let {
    title = 'Warning',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.313 21.344v-5.375h-2.625v5.375h2.625zM17.313 26.656v-2.688h-2.625v2.688h2.625zM1.313 30.656l14.688-25.313 14.688 25.313h-29.375z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Warning);
Warning.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Warning",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Warning'",
        "computed": false
      },
      "required": false
    }
  }
};